import { render, staticRenderFns } from "./name.vue?vue&type=template&id=0be9135e&scoped=true&"
import script from "./name.vue?vue&type=script&lang=js&"
export * from "./name.vue?vue&type=script&lang=js&"
import style0 from "./name.vue?vue&type=style&index=0&id=0be9135e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be9135e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0be9135e')) {
      api.createRecord('0be9135e', component.options)
    } else {
      api.reload('0be9135e', component.options)
    }
    module.hot.accept("./name.vue?vue&type=template&id=0be9135e&scoped=true&", function () {
      api.rerender('0be9135e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/game/validation/name.vue"
export default component.exports